import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import Checkbox from '@mui/material/Checkbox';


export const DATA_MANAGER_COLUMNS = (openModal, setSelectedRow)=>{
    return [       
        {field:"email", headerName:"Email", flex:1},
        {field:"complete_name", headerName:"Full Name", flex:1},       
        { field: 'is_active', headerName: 'Is Active', flex: 1,
            renderCell: (props) => {
                return (<Checkbox 
                            disabled
                            checked={props.row.is_active == 1} />)
            }
        },       
        { field: 'admin', headerName: 'Admin', flex: 1,
            renderCell: (props) => {
                return (<Checkbox 
                            disabled
                            checked={props.row.admin == 1} />)
            }
        },       
        { field: 'can_approve', headerName: 'Can Approve', flex: 1,
            renderCell: (props) => {
                return (<Checkbox 
                            disabled
                            checked={props.row.can_approve == 1} />)
            }
        },
        { field: 'can_deliver', headerName: 'Can Deliver', flex: 1,
            renderCell: (props) => {
                return (<Checkbox 
                            disabled
                            checked={props.row.can_deliver == 1} />)
            }
        },
        {   headerName: 'Show Details',
            renderCell: (props) => {
                return (
                    <Button 
                        color={"#000"} 
                        onClick={()=>{
                            openModal('editUser',{lease_id:props.row.id})
                            setSelectedRow(props.row)
                        }}>
                        <FileOpenIcon />
                    </Button>
                )
            }
        }
    ]
}
